import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useCustomerStore } from '@/storage/customer'
import ContractorComplianceCheck from '@/views/ContractorComplianceCheck.vue'
import { useUserStore } from '@/storage/user'

const guard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const store = useCustomerStore()
  const userStore = useUserStore()

  if (store.hasContractorManagement && userStore.hasSelectedContractorCompany) {
    next()
  } else {
    next({ name: 'checkAccreditation' })
  }
}

export default {
  beforeEnter: guard,
  component: ContractorComplianceCheck,
  meta: {
    loadingMessage: 'Checking contractor compliance...',
    showMenu: true,
  },
  name: 'contractorCompliance',
  path: '/contractor/compliance',
}
